// 产品展示
export default[

  {
    path: '/product/fundList',
    name: '基金份额转让',
    component: () => import(/* webpackChunkName: 'product' */ '@/views/product/fundList.vue')
  },
  {
    path: '/product/fundDetail/:id',
    name: '基金份额转让详情',
    component: () => import(/* webpackChunkName: 'product' */ '@/views/product/fundDetail.vue')
  },
  {
    path: '/product/quoteList',
    name: '股权转让',
    component: () => import(/* webpackChunkName: 'product' */ '@/views/product/quoteList.vue')
  },
  {
    path: '/product/quoteDetail/:id',
    name: '股权转让详情',
    component: () => import(/* webpackChunkName: 'product' */ '@/views/product/quoteDetail.vue')
  },
  {
    path: '/product/companyDetail',
    name: '投资公司详情',
    component: () => import(/* webpackChunkName: 'product' */ '@/views/product/companyDetail.vue')
  }

]



// WEBPACK FOOTER //
// ./src/router/moudles/productRouter.js